<template>
  <div id="container" class="slds-align_absolute-center">
    <div class="slds-card slds-m-around--large">
      <div class="slds-p-around_medium">
        This application is for use in the Salesforce Marketing Cloud Content Builder Editor only.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Info"
}
</script>

<style scoped>
#container {
  height: 100vh;
}
</style>